module.exports = __webpack_public_path__ + "img/m6-Walgreens.de666b0c.png";